import React, { useState } from "react";
import { TextInput, Button } from "../indexComponents";

function JoinTeamForm({ onTeamJoined, close }) {
  const [teamCode, setTeamCode] = useState("");

  const joinTeam = async (event) => {
    event.preventDefault();
    console.log();

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/join-team`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
          body: JSON.stringify({
            team_code: teamCode,
          }),
        }
      );

      if (!response.ok) {
        throw new Error("Failed to join team");
      }

      setTeamCode("");
      onTeamJoined();
      close();
    } catch (error) {
      console.error("Error joinning team:", error);
    }
  };

  return (
    <div className="JoinTeamForm">
      <form>
        <TextInput
          labelText="Code de l'équipe"
          name="team_code"
          type="text"
          placeholder=""
          value={teamCode}
          onChange={(e) => setTeamCode(e.target.value)}
          maxLength={8}
        />
        <div className="btn-container">
          <Button
            className="create-team-btn"
            onClick={joinTeam}
            text="Rejoindre"
          />
          <Button onClick={close} text="Annuler" />
        </div>
      </form>
    </div>
  );
}

export default JoinTeamForm;
